/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import GameSetup from '../../Game/GameSetup';
import EditorComponentBase from '../Prefab/EditorComponentBase';
import { RequestType } from '../RequestType';
import TypeStrings from '../TypeStrings';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

export interface ILoginResponse
{
    accessToken: string;
}

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
@cc._decorator.requireComponent(GameSetup)
export default class TokenReferesher extends EditorComponentBase
{
    protected gameSetup: GameSetup = null;

    @property
    public set Refresh(value: boolean) { this.refreshToken(true); }
    public get Refresh(): boolean { return false; }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad('TOKEN REFRESHER');
        if (!CC_EDITOR)
        {
            this.destroy();
            return;
        }

        this.gameSetup = this.getComponent(GameSetup);
        this.refreshToken();
    }

    private refreshToken(buttonClick: boolean = false): void
    {
        if (!this.enabled && !buttonClick) { return; }

        let request: XMLHttpRequest = cc.loader.getXMLHttpRequest();
        let url: string = new URL(this.gameSetup.ClientDefaults.serverHost).origin;
        let params: object =
        {
            username: this.gameSetup.ClientDefaults.userId,
            password: 'password',
            gameName: this.gameSetup.ClientDefaults.gameId
        };

        url += url.endsWith('/') ? 'login?' : '/login?';
        Object.keys(params).forEach((key) => url += `${key}=${params[key]}&`);

        request.open(RequestType[this.gameSetup.RGSServerSettings.RequestType], url, true);
        request.onreadystatechange = () =>
        {
            if (request.readyState !== 4) { return; }
            if (request.status !== 200 || !request.responseText)
            {
                this.error(`Failed to refresh token, status: [${request.status}].`);
                return;
            }

            // Success
            try
            {
                const loginResponse: ILoginResponse = typeof(request.responseText) === TypeStrings.string
                    ? JSON.parse(request.responseText)
                    : request.responseText;

                if (loginResponse.accessToken)
                {
                    this.log(`NEW TOKEN: ${loginResponse.accessToken}`);
                }
                else
                {
                    this.error('Malformed response.');
                    return;
                }

                this.gameSetup.ClientDefaults.userToken = loginResponse.accessToken;
            }
            catch (error)
            {
                this.error(`Error updating token: [${error.message}].`);
                return;
            }
        };
        request.send();
    }
}
